import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Moment } from 'moment';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { CountryDTO, ShowCase } from 'src/app/api/models';
import { AllocationSelectOption } from 'src/app/api/models/trays-dto';
import { FILTER_TYPE } from 'src/app/enums/filters.constants';
import { LOGISTIC_STATUS_VALUES, LogisticStatus } from 'src/app/enums/logistic-status-enum';
import { ProductStatus } from 'src/app/enums/product-status-enum';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-bulgari-filter',
  templateUrl: './bulgari-filter.component.html',
  styleUrls: ['./bulgari-filter.component.scss']
})
export class BulgariFilterComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @Output() handleFiltersChange = new EventEmitter();

  @Input() loading?: string[];
  @Input() type?: string;
  @Input() hasDate = false;
  @Input() hasSearch = false;
  @Input() hasSapCodeSearch = false;
  @Input() countries: CountryDTO[] = [];
  @Input() placeholderSearch = 'PAGES.FILTER.SEARCH_SAP_CODE';
  @Input() selectOptions!: {
    commonOptions: any[],
    showcases: any[]
  };
  @Input() initialDate?: any;
  @Input() financeFilterOptions?: any;

  @Output() applyFilters = new EventEmitter();
  @Output() resetFilters = new EventEmitter();

  @ViewChild('formRef') formRef!: ElementRef;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkIfShowMoreAndLessButtonsShouldBeVisible();
  }

  readonly COUNTRIES = "countries";
  readonly LOGISTIC_STATUSES = "logisticStatuses";
  readonly ALLOCATION_STATUSES = "allocationStatuses";
  readonly FINANCE_COUNTRIES = "financeCountries";
  readonly FINANCE_DATES = "financeDates";

  selectStatus = [
    ProductStatus.NOT_AVAILABLE,
    ProductStatus.AVAILABLE,
    ProductStatus.IN_APPOINTMENT,
    // ProductStatus.UNLOCK,
    ProductStatus.BOOKED_FOR_SALES,
    ProductStatus.BROKEN,
    ProductStatus.WEAR,
    ProductStatus.CLIENT_VIEW,
    ProductStatus.UNDER_NEGOTIATION
  ];

  logisticStatuses = [
    {
      value: LOGISTIC_STATUS_VALUES[LogisticStatus.ARRIVED],
      name: `PAGES.FILTER.${LogisticStatus.ARRIVED.toUpperCase()}`
    },
    {
      value: LOGISTIC_STATUS_VALUES[LogisticStatus.NOT_ARRIVED],
      name: `PAGES.FILTER.${LogisticStatus.NOT_ARRIVED.toUpperCase()}`
    },
    {
      value: LOGISTIC_STATUS_VALUES[LogisticStatus.OUT],
      name: `PAGES.FILTER.${LogisticStatus.OUT.toUpperCase()}`
    },
    {
      value: LOGISTIC_STATUS_VALUES[LogisticStatus.BROKEN],
      name: `PAGES.FILTER.${LogisticStatus.BROKEN.toUpperCase()}`
    },
    {
      value: LOGISTIC_STATUS_VALUES[LogisticStatus.WEAR],
      name: `PAGES.FILTER.${LogisticStatus.WEAR.toUpperCase()}`
    },
  ]

  allocationStatuses = [
    {
      value: ProductStatus.NOT_AVAILABLE,
      name: `PAGES.FILTER.ALLOCATION_STATUSES.${ProductStatus.NOT_AVAILABLE}`
    },
    {
      value: ProductStatus.AVAILABLE,
      name: `PAGES.FILTER.ALLOCATION_STATUSES.${ProductStatus.AVAILABLE}`
    },
    {
      value: ProductStatus.IN_APPOINTMENT,
      name: `PAGES.FILTER.ALLOCATION_STATUSES.${ProductStatus.IN_APPOINTMENT}`
    },
    {
      value: ProductStatus.BOOKED_FOR_SALES,
      name: `PAGES.FILTER.ALLOCATION_STATUSES.${ProductStatus.BOOKED_FOR_SALES}`
    },
    {
      value: ProductStatus.CLIENT_VIEW,
      name: `PAGES.FILTER.ALLOCATION_STATUSES.${ProductStatus.CLIENT_VIEW}`
    },
    {
      value: ProductStatus.UNDER_NEGOTIATION,
      name: `PAGES.FILTER.ALLOCATION_STATUSES.${ProductStatus.UNDER_NEGOTIATION}`
    },
    {
      value: ProductStatus.BACKUP,
      name: `PAGES.FILTER.ALLOCATION_STATUSES.${ProductStatus.BACKUP}`
    },
  ]

  showMoreFilters: boolean = false;
  showMoreAndLessButtons: boolean = true;

  private destroy$ = new Subject<void>();

  form: FormGroup = new FormGroup({});

  constructor(
    private fb: FormBuilder,
    public sharedService: SharedService
  ) {
    this.form = this.fb.group({
      searchFormControl: new FormControl(''),
      sapCodeFormControl: new FormControl(''),
      statusFormControl: new FormControl(''),
      hasImageControl: new FormControl(''),
      hasBookedForSale: new FormControl(''),
      productStatusControl: new FormControl(''),
      dateFormControl: new FormControl<any>(null),
      showCaseControl: new FormControl([]),
      trayControl: new FormControl([]),
      countriesFormControl: new FormControl<any>([]),
      financeCountriesFormControl: new FormControl<any>([]),
      financeDatesFormControl: new FormControl<any>(null),
      logisticStatusesFormControl: new FormControl<any>([]),
      allocationStatusesFormControl: new FormControl<any>([]),
      bfsFormControl: new FormControl<boolean | undefined>(undefined),
    })
  }

  ngOnInit(): void {
    if (this.isExtraTraysType()) {
      this.form.get("dateFormControl")?.patchValue(this.sharedService.getDayInEventRange(new Date(), true));

      //   let today = moment();
      //   let eventLastDate = this.sharedService.getMaxDateEvent(true);
      //   let eventFirstDate = this.sharedService.getMinDateEvent(true);
      //   if (today.isAfter(moment(eventLastDate))) {
      //     this.dateFormControl.patchValue(eventLastDate);
      //   } else if (today.isBefore(moment(eventFirstDate))) {
      //     this.dateFormControl.patchValue(eventFirstDate);
      //   } else {
      //     this.dateFormControl.patchValue(today.toDate());
      //   }
    }

    this.form.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((val) => this.handleFiltersChange.emit(val));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes)
    const date = changes["initialDate"]?.currentValue;
    if ("initialDate" in changes) {
      // this.dateFormControl.patchValue(this.sharedService.getDayInEventRange(new Date(), true));
      this.form.get("dateFormControl")?.patchValue(date || null);
    }
    const selectOptions = changes["selectOptions"]?.currentValue;
    if ("selectOptions" in changes) {
      console.log("changed", selectOptions);
      this.form.get("trayControl")?.reset([]);
    }
  }

  ngAfterViewInit(): void {
    this.checkIfShowMoreAndLessButtonsShouldBeVisible();
  }

  applySearch() {
    switch (true) {
      case this.isFinanceType(): {
        this.financeSearch();
        break;
      }
      case this.isAnalyticsAppointmentsType(): {
        this.analyticsAppointmentsSearch();
        break;
      }
      case this.isAnalyticsProductsType(): {
        this.analyticsProductsSearch();
        break;
      }
      case this.isActivitiesType(): {
        this.applyFilters.emit({ search: this.form.value.searchFormControl?.trim(), date: this.form.value.dateFormControl });
        break;
      }
      case this.isBfsType(): {
        this.applyFilters.emit({ search: this.form.value.searchFormControl?.trim(), sapCodes: this.form.value.sapCodeFormControl });
        break;
      }
      case this.isAllocationType():
      case this.isTraysType():
      case this.isExtraTraysType(): {
        this.productAllocationSearch()
        break;
      }
      case this.isWatchesType(): {
        this.applyFilters.emit({ search: this.form.value.searchFormControl?.trim(), sapCodes: this.form.value.sapCodeFormControl });
        break;
      }
      case this.isProductsType(): {
        this.productsSearch();
        break;
      }
      default: break;
    }
  }

  financeSearch() {
    let searchBody: any = {};
    searchBody.FullText = this.form.value.searchFormControl;
    if (this.form.value.financeCountriesFormControl && Array.isArray(this.form.value.financeCountriesFormControl)) {
      searchBody.Countries = this.form.value.financeCountriesFormControl.map((val: any) => val.id);
    }
    if (this.form.get("financeDatesFormControl")) {
      searchBody.Data = this.form.value.financeDatesFormControl;
    }
    if (Object.keys(searchBody).length > 0) {
      this.applyFilters.emit(searchBody);
    }
  }


  productsSearch() {
    let searchBody: any = {};
    searchBody.search = this.form.value.searchFormControl;
    searchBody.sapCodes = this.form.value.sapCodeFormControl;
    if (this.form.value.logisticStatusesFormControl && Array.isArray(this.form.value.logisticStatusesFormControl)) {
      searchBody.Statuses = this.form.value.logisticStatusesFormControl.map((val: any) => val.value);
    }
    if (this.form.value.allocationStatusesFormControl && Array.isArray(this.form.value.allocationStatusesFormControl)) {
      searchBody.AllocationStatus = this.form.value.allocationStatusesFormControl.map((val: any) => val.value);
    }
    this.applyFilters.emit(searchBody);
  }

  analyticsAppointmentsSearch() {
    let searchBody: any = {};
    searchBody.FullText = this.form.value.searchFormControl;
    if (this.form.value.dateFormControl) {
      let date: Moment = this.form.value.dateFormControl;
      if (date.isValid()) {
        searchBody.Data = date.format("YYYY-MM-DD");
      }
    }
    if (this.form.value.countriesFormControl && Array.isArray(this.form.value.countriesFormControl)) {
      searchBody.Country = this.form.value.countriesFormControl;
    }
    if (Object.keys(searchBody).length > 0) {
      this.applyFilters.emit(searchBody);
    }
  }

  analyticsProductsSearch() {
    let searchBody: any = {};
    searchBody.FullText = this.form.value.searchFormControl;
    if (typeof this.form.value.bfsFormControl === "boolean") {
      searchBody.BookedForSale = this.form.value.bfsFormControl;
    }
    if (Object.keys(searchBody).length > 0) {
      this.applyFilters.emit(searchBody);
    }
  }

  productAllocationSearch() {
    const trays: any = this.form.value.trayControl || [];
    const showcases: any = this.form.value.showCaseControl || [];
    const searchResult = this.form.value.searchFormControl?.trim() || '';
    let referenceDate = null;
    if (this.form.value.dateFormControl) {
      referenceDate = moment(this.form.value.dateFormControl).format("YYYY-MM-DD");
    }
    let payload: any = {
      search: searchResult,
      trays: trays,
      showcases: showcases,
      sapCodes: this.form.value.sapCodeFormControl,
    };
    if (this.isProductAllocationType()) {
      payload.referenceDate = referenceDate;
    }
    if (this.isAllocationType()) {
      const hasImage = this.form.value.hasImageControl;
      if (typeof hasImage === 'boolean') {
        payload.hasImage = hasImage;
      }
      const productStatus = this.form.value.productStatusControl;
      if (typeof productStatus === 'number') {
        payload.productStatus = productStatus;
      }
    }
    if (this.isExtraTraysType()) {
      const hasBookedForSale = this.form.value.hasBookedForSale;
      if (typeof hasBookedForSale === 'boolean') {
        payload.hasBookedForSale = hasBookedForSale;
      }
    }
    this.applyFilters.emit(payload);
  }

  onShowcaseRemoved(showcase: string) {
    const shws = this.form.value.showCaseControl!;
    this.removeFirst(shws, showcase);
    this.form.get("showCaseControl")?.setValue(shws); // To trigger change detection
  }

  onTrayRemoved(tray: string) {
    const trays = this.form.value.trayControl!;
    this.removeFirst(trays, tray);
    this.form.get("trayControl")?.setValue(trays); // To trigger change detection
  }

  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  translateSelectShowcase(sc: ShowCase) {
    let result = sc.description;
    if (sc.area) {
      result += " - " + sc.area
    }
    return result;
  }

  getTrayCode(tray: AllocationSelectOption) {
    return tray.description;
  }

  reset() {
    this.form.setValue({
      showCaseControl: [],
      trayControl: [],
      countriesFormControl: [],
      financeCountriesFormControl: [],
      financeDatesFormControl: null,
      dateFormControl: null,
      searchFormControl: '',
      sapCodeFormControl: '',
      statusFormControl: '',
      hasImageControl: '',
      hasBookedForSale: '',
      productStatusControl: '',
      bfsFormControl: '',
      logisticStatusesFormControl: [],
      allocationStatusesFormControl: [],
    });
    console.log('reset')
    this.resetFilters.emit();
  }

  triggerEvent(flag: boolean) {
    // if (flag === false) {
    //   this.apply();
    // }
  }

  checkIfShowMoreAndLessButtonsShouldBeVisible() {
    let widthSum = 0;
    try {
      let children = Array.prototype.slice.call(this.formRef.nativeElement.children);
      if (children.length === 1) {
        this.showMoreAndLessButtons = false;
        this.showMoreFilters = true;
      } else {
        children.forEach(elem => {
          //Aggiungo 16 per un offset approssimativo relativo al gap di "1em" del form
          widthSum += elem.offsetWidth + 16;
        });
        if (this.formRef.nativeElement.offsetWidth < widthSum && this.showMoreAndLessButtons === false) {
          this.showMoreAndLessButtons = true;
        } else if (this.formRef.nativeElement.offsetWidth > widthSum && this.showMoreAndLessButtons === true) {
          this.showMoreAndLessButtons = false;
        }
      }
    }
    catch (err) {
      console.log(err);
    }
  }

  showFilters(flag: boolean) {
    this.showMoreFilters = flag;
  }

  showDatePicker() {
    return this.isProductAllocationType()
  }

  isAnalyticsAppointmentsType() {
    return this.type === FILTER_TYPE.ANALYTICS_APPOINTMENTS;
  }

  isAnalyticsProductsType() {
    return this.type === FILTER_TYPE.ANALYTICS_PRODUCTS;
  }

  isActivitiesType() {
    return this.type === FILTER_TYPE.ACTIVITIES;
  }

  isBfsType() {
    return this.type === FILTER_TYPE.BFS;
  }

  isProductAllocationType() {
    return this.isAllocationType() || this.isTraysType() || this.isExtraTraysType();
  }

  isTraysType() {
    return this.type === FILTER_TYPE.TRAYS;
  }

  isExtraTraysType() {
    return this.type === FILTER_TYPE.EXTRA_TRAYS;
  }

  isWatchesType() {
    return this.type === FILTER_TYPE.WATCHES;
  }

  isAllocationType() {
    return this.type === FILTER_TYPE.ALLOCATION;
  }

  isProductsType() {
    return this.type === FILTER_TYPE.PRODUCTS;
  }

  isFinanceType() {
    return this.type === FILTER_TYPE.FINANCE;
  }

  removeChip(type: string, value: any) {
    let data = null;
    switch (type) {
      case this.FINANCE_COUNTRIES: {
        data = this.form.value.financeCountriesFormControl!;
        this.removeFirst(data, value);
        this.form.get("financeCountriesFormControl")?.setValue(data);
        break;
      }
      case this.COUNTRIES: {
        data = this.form.value.countriesFormControl!;
        this.removeFirst(data, value);
        this.form.get("countriesFormControl")?.setValue(data);
        break;
      }
      case this.LOGISTIC_STATUSES: {
        data = this.form.value.logisticStatusesFormControl!;
        this.removeFirst(data, value);
        this.form.get("logisticStatusesFormControl")?.setValue(data);
        break;
      }
      case this.ALLOCATION_STATUSES: {
        data = this.form.value.allocationStatusesFormControl!;
        this.removeFirst(data, value);
        this.form.get("allocationStatusesFormControl")?.setValue(data);
        break;
      }
    }
  }

  clearDate() {
    this.form.get("dateFormControl")?.setValue(null)
  }

  getCountryName(countryCode: string) {
    let country = this.countries.find(c => c.code === countryCode);
    if (country) {
      return country.name
    }
    return countryCode;
  }

  compareTrays(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.code === o2.code : o1 === o2;
    // return o1 && o2 ? o1.description === o2.description : o1 === o2;
  }
}
